"use client";

import { WalletButton } from "@/components/features/wallet/WalletButton";
import { CedeHubLogo as CedeHubLogoM } from "@/components/icons";
import { cn } from "@/lib/utils";

interface WalletSectionTMAProps {
  className?: string;
}

export const WalletSectionTMA = ({ className }: WalletSectionTMAProps) => {
  return (
    <div className={cn("flex items-center justify-between", className)}>
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 flex items-center justify-center">
          <CedeHubLogoM />
        </div>
        <span className="text-cede-text-primary text-lg font-semibold">Cede Hub</span>
      </div>
      <WalletButton className="flex-shrink-0" />
    </div>
  );
};
